// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-Report-TopCustomerReport-style__form--vqunj{display:flex;margin-bottom:1em;align-items:center}.src-Report-TopCustomerReport-style__topSelect--XKUpL{display:flex;align-items:center}.src-Report-TopCustomerReport-style__topSelect--XKUpL>div{width:3em}.src-Report-TopCustomerReport-style__topSelect--XKUpL>span{margin-right:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "src-Report-TopCustomerReport-style__form--vqunj",
	"topSelect": "src-Report-TopCustomerReport-style__topSelect--XKUpL"
};
export default ___CSS_LOADER_EXPORT___;
